/**
 * @file The short label of every `AnalyticsPeriod`, keyed by period.
 * Consumers: the Reports tab's Period column and create form, and a stored
 * run's provenance. The `Record` type fails the build when a period is added
 * without a label.
 */
import type { AnalyticsPeriod } from '#types';

export const ANALYTICS_PERIOD_LABELS: Record<AnalyticsPeriod, string> = {
  ytd: 'YTD',
  qtd: 'QTD',
  mtd: 'MTD',
  wtd: 'WTD',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
};
